import { CLASS_NAME_DEFAULT } from "../../constants"

type WrapperProps = {
  children: React.ReactNode
  className?: string
  theme: "danger" | "success" | "warning" | "info" | "disabled" | "alt"
}

type Props = {
  className?: string
  children: React.ReactNode
}

const Wrapper = ({
  children,
  theme,
  className = CLASS_NAME_DEFAULT
}: WrapperProps) => (
  <span className={`badge badge-${theme} ${className}`}>{children}</span>
)

const Danger = (props: Props) => {
  return <Wrapper {...props} theme="danger" />
}

const Info = (props: Props) => {
  return <Wrapper {...props} theme="info" />
}

const Warning = (props: Props) => {
  return <Wrapper {...props} theme="warning" />
}

const Success = (props: Props) => {
  return <Wrapper {...props} theme="success" />
}

const Disabled = (props: Props) => {
  return <Wrapper {...props} theme="disabled" />
}

const Alt = (props: Props) => {
  return <Wrapper {...props} theme="alt" />
}

const Badge = { Danger, Info, Warning, Success, Disabled, Alt }

export default Badge
